import { injectable } from "inversify";
import events from "../events/EventsObservable";
import { ERROR_EVENTS } from "../connect/controllers/ConnectControl";
import MadmaxMessageCooldown from "../ui/messages/MadmaxMessageCooldown";
import { STATES } from "../states/states";
import IMadmaxMessage from "../ui/messages/IMadmaxMessage";
import { MESSAGE_EVENTS } from "../error/errorMessages";
import MadmaxMessage from "../ui/messages/MadmaxMessage";
import Regulation from "./Regulation";

@injectable()
class CzRegulation extends Regulation {
	private _msg: IMadmaxMessage;

	init() {
		super.init();
		events.subscribe(
			ERROR_EVENTS.ERROR_REGULATION_COOLDOWN,
			(eventName, data) => this.cooldown(data)
		);
	}

	cooldown(data) {
		this._getErrorMessage(data);
		(this._msg as MadmaxMessageCooldown).hideTime();
		(this._msg as MadmaxMessageCooldown).hideButtons();
		setTimeout(() => {
			(this._msg as MadmaxMessageCooldown).showButtons();
		}, 3000);
	}

	_getErrorMessage(data) {
		this._msg = this._messages.getErrorMessage(data);
		this._msg.setOnClose(() => {
			this._game.regulationEnableGame(true);
			this._statesManager.setState(STATES.IDLE);
		});
		this._msg.openMessage();
		if ((this._msg as MadmaxMessage).buttonsElement.children.length === 0) {
			(this._msg as MadmaxMessage).addButton(
				{ event: MESSAGE_EVENTS.MESSAGE_CLOSE },
				"ok"
			);
		}
	}
}

export default CzRegulation;
